import React from 'react';

const Location = (props) => (
  <div style={{ height: '160px', width: '230px' }}></div>
);

export default Location;
